import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ToggleRow from '../../../../components/toggle-row/ToggleRow';
import SmallJSONEditor from '../../../../components/small-json-editor/SmallJSONEditor';
import ValidationService from '../../../../services/ValidationService';
import RESTService from '../../../../services/RESTService';
import Dropdown from '../../../../components/dropdown/Dropdown';
import RoutingService from '../../../../services/RoutingService';
import ComponentHelper from '../../../../supers/ComponentHelper';
import TestRunnerModal from '../../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../../services/CommonService';
import _ from 'lodash';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();

class ExchangeWebServiceConnector extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = this.defaultState();
		this.scanForParams();
		this.autoBind(['buildTypeDefault', 'scanForParams', 'onSetEmpty', 'onClearValue', 'onDefaultChange', 'getIsDisabled']);
	}

	getIsDisabled(field) {
		return this.data.disabled[field];
	}

	defaultState = () => {
		if (this.props.connection) {
			return this.onBuildConnectionState(this.props.connection);
		}
		return {
			testing: false,
			authOpen: false,
			headersOpen: false,
			bodyOpen: false,
			sslOpen: true,
			runningTest: false,
			agents: [],
			agentContent: '',
			agentsOpen: false,
			actionType: '',
			name: '',
			url: '',
			username: '',
			password: '',
			timeout: 0,
			serverVersion: 'Not specified',
			headersContent: '',
			bodyContent: '',
			smtpAddress: '',
			impersonationMethod: 'Not specified',
			additionalHeadersContent: '',
			securityMethodId: '',
			primarySmtpAddress: '',
			principalName: '',
			requestParams: {},
			disabled: {}
		};
	};

	componentDidMount() {
		connect.getAgents().then(res => {
			this.setData('agents', res.data);
		});
	}

	onBuildConnectionState(conn) {
		let config = conn.configuration;
		let auth = config.auth || {};
		let headers = config.headers || {};
		let impersonationMethod = '';
		let principalName = '';
		let securityMethodId = '';
		let primarySmtpAddress = '';
		let smtpAddress = '';

		if (headers && headers.ExchangeImpersonation) {
			var connectionKey = Object.keys(headers.ExchangeImpersonation.ConnectingSID);
			impersonationMethod = connectionKey[0];

			if (impersonationMethod === 'PrincipalName') {
				principalName = headers.ExchangeImpersonation.ConnectingSID[impersonationMethod];
			} else if (impersonationMethod === 'SID') {
				securityMethodId = headers.ExchangeImpersonation.ConnectingSID[impersonationMethod];
			} else if (impersonationMethod === 'PrimarySmtpAddress') {
				primarySmtpAddress = headers.ExchangeImpersonation.ConnectingSID[impersonationMethod];
			} else if (impersonationMethod === 'SmtpAddress') {
				smtpAddress = headers.ExchangeImpersonation.ConnectingSID[impersonationMethod];
			}
		}

		let state = {
			testing: conn.testing,
			actionType: '',
			authOpen: auth ? true : false,
			outputDefOpen: config.template ? true : false,
			headersOpen: config.headers ? true : false,
			bodyOpen: config.body ? true : false,
			agents: this.data.agents ? this.data.agents : [],
			agentContent: conn.agent ? conn.agent : '',
			agentsOpen: conn.agent && conn.agent.length > 0 ? true : false,
			name: conn.name,
			type: conn.type,
			url: config.url ? config.url : '',
			path: config.path ? config.path : '',
			timeout: config.timeout ? config.timeout : 0,
			parseJsonResponse: config.json,
			sslOpen: config.strictSSL,
			serverType: headers.RequestServerVersion ? headers.RequestServerVersion.attributes.Version : '',
			username: auth.username ? auth.username : '',
			password: auth.password ? auth.password : '',
			additionalHeadersContent: headers ? JSON.stringify(headers, undefined, 2) : '',
			bodyContent: config.body ? JSON.stringify(config.body, undefined, 2) : '',
			runningTest: false,
			requestParams: {},
			disabled: {},
			impersonationMethod,
			principalName,
			securityMethodId,
			primarySmtpAddress,
			smtpAddress
		};

		let disabled = {};
		if (state.testing || this.props.endpoint) {
			if (state.url.length > 0) {
				disabled.url = true;
			}
			if (state.username.length > 0) {
				disabled.username = true;
			}
			if (state.password.length > 0) {
				disabled.password = true;
			}
			if (state.additionalHeadersContent.length > 0) {
				disabled.additionalHeadersContent = true;
			}
			if (state.bodyContent.length > 0) {
				disabled.bodyContent = true;
			}
			if (state.principalName && state.principalName.length > 0) {
				disabled.principalName = true;
			}
			if (state.securityMethodId && state.securityMethodId.length > 0) {
				disabled.securityMethodId = true;
			}
			if (state.primarySmtpAddress && state.primarySmtpAddress.length > 0) {
				disabled.primarySmtpAddress = true;
			}
			if (state.smtpAddress && state.smtpAddress.length > 0) {
				disabled.smtpAddress = true;
			}
			if (state.impersonationMethod && state.impersonationMethod.length > 0) {
				disabled.impersonationMethod = true;
			}
			if (state.serverType && state.serverType.length > 0) {
				disabled.serverType = true;
			}
			if (state.agentsOpen) {
				disabled.agent = true;
			}
		}
		state.disabled = disabled;
		return state;
	}

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.setData(name, value);
	};

	onChecked = evt => {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	};

	onActionChange = evt => {
		this.setData('actionType', evt.target.value);
	};

	onServerChange = evt => {
		this.setData('serverType', evt.value);
	};

	onImpersonationMethodChange = evt => {
		this.setData('impersonationMethod', evt.value);
	};

	onClearConnection = () => {
		this.observe(() => {
			this.data = this.defaultState();
		});
	};

	buildTestConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			return false;
		}
		//TODO maybe add in config checks here?
		let testData = CS.buildRequestTestData(this.data.requestParams);
		testData._async = this.data.async ? true : false;
		return {
			application: 'global',
			sandbox: RS.getCurrentEnvironment(),
			endpoint: {
				action: this.data.actionType,
				configuration: connection.configuration,
				connection: connection.name,
				templates: CS.buildRequestTemplate(this.data.requestParams),
				type: 'operation'
			},
			testValues: testData
		};
	};

	onTestConnection = () => {
		return connect.testConnection(this.buildTestConnection());
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	runTest = () => {
		this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		this.observe(() => {
			this.data.runningTest = true;
		});
	};

	isValidConnection = () => {
		if (this.data.name.length > 0) {
			return false;
		}
		return true;
	};

	onCreateConnection = () => {
		alert('Connection Created!');
	};

	handleAdditionalHeadersChange = newValue => {
		this.observe(() => {
			this.data.additionalHeadersContent = newValue;
			this.scanForParams();
		});
	};

	handleBodyChange = newValue => {
		this.observe(() => {
			this.data.bodyContent = newValue;
			this.scanForParams();
		});
	};

	onBuildConnection = () => {
		this.invalidForm = false;
		let data = this.data;
		let connection = {
			name: data.name,
			type: 'exchange-connector',
			configuration: {
				url: data.url,
				strictSSL: data.sslOpen,
				json: data.parseJsonResponse
			}
		};

		if (data.timeout >= 0) {
			connection.timeout = data.timeout;
		}

		connection.configuration.auth = {
			username: data.username,
			password: data.password
		};

		if (data.headersOpen) {
			if (data.additionalHeadersContent.length > 0) {
				let val = CS.safelyParseJSON(data.additionalHeadersContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.headers = val;
			} else {
				connection.configuration.headers = {};
			}

			const headers = connection.configuration.headers;

			if (data.serverType && data.serverType.length > 0 && data.serverType !== 'Not specified') {
				const requestServerVersion = (headers.RequestServerVersion = {
					attributes: {
						xmlns: 'http://schemas.microsoft.com/exchange/services/2006/types',
						'xmlns:ns': 'http://schemas.microsoft.com/exchange/services/2006/types'
					}
				});

				if (data.serverType === 'Exchange2007') {
					requestServerVersion.attributes.Version = 'Exchange2007';
				} else if (data.serverType === 'Exchange2007_SP1') {
					requestServerVersion.attributes.Version = 'Exchange2007_SP1';
				} else if (data.serverType === 'Exchange2010') {
					requestServerVersion.attributes.Version = 'Exchange2010';
				} else if (data.serverType === 'Exchange2010_SP1') {
					requestServerVersion.attributes.Version = 'Exchange2010_SP1';
				} else if (data.serverType === 'Exchange2010_SP2') {
					requestServerVersion.attributes.Version = 'Exchange2010_SP1';
				}
			}

			if (data.impersonationMethod && data.impersonationMethod.length > 0 && data.impersonationMethod !== 'Not specified') {
				const exchangeImpersonate = (headers.ExchangeImpersonation = {
					attributes: {
						xmlns: 'http://schemas.microsoft.com/exchange/services/2006/types',
						'xmlns:ns': 'http://schemas.microsoft.com/exchange/services/2006/types'
					},
					ConnectingSID: {}
				});

				if (data.impersonationMethod === 'PrincipalName') {
					exchangeImpersonate.ConnectingSID[data.impersonationMethod] = data.principalName;
				} else if (data.impersonationMethod === 'SID') {
					exchangeImpersonate.ConnectingSID[data.impersonationMethod] = data.securityMethodId;
				} else if (data.impersonationMethod === 'PrimarySmtpAddress') {
					exchangeImpersonate.ConnectingSID[data.impersonationMethod] = data.primarySmtpAddress;
				} else if (data.impersonationMethod === 'SmtpAddress') {
					exchangeImpersonate.ConnectingSID[data.impersonationMethod] = data.smtpAddress;
				}
			}
		}

		if (data.bodyOpen) {
			if (data.bodyContent.length > 0) {
				let val = CS.safelyParseJSON(data.bodyContent);
				if (!val) {
					this.invalidForm = true;
					return;
				}
				connection.configuration.body = val;
			}
		}

		if (data.agentsOpen) {
			connection.agent = data.agentContent;
		} else {
			connection.agent = '';
		}

		return connection;
	};

	onCreateConnection = () => {
		let connection = this.onBuildConnection();
		if (this.invalidForm) {
			RS.smartError('Invalid JSON');
			return;
		}
		if (this.props.connection) {
			delete connection.type;
			connect
				.updateConnection(connection)
				.then(res => {
					this.observe(() => {
						this.data = this.onBuildConnectionState(res.data);
					});
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createConnection(connection)
				.then(() => {
					RS.showSuccess();
					RS.goToRoute('/connections');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	scanForParams() {
		let keys = ['additionalHeadersContent', 'bodyContent'];
		this.data.requestParams = CS.buildRequestParams(keys, this.data);
		if (this.props.endpointWatcher) {
			this.props.endpointWatcher({
				cmp: this,
				data: this.data,
				builder: this.buildTestConnection
			});
		}
	}

	onSetEmpty(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = '';
			});
		}
	}

	onClearValue(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				this.data.requestParams[name].value = undefined;
			});
		}
	}

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field = this.data.requestParams[name];
				field.value = evt.target.value;
				this.data.requestParams[name] = field;
			});
		}
	}

	buildTypeDefault(details, param) {
		return (
			<div className="inline-btn-input hbox vcenter default">
				<input
					className="text-input"
					type="text"
					placeholder={details.value === '' ? 'Empty String' : 'None'}
					value={details.value}
					data-name={param}
					onChange={this.onDefaultChange}
				/>
				<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
					Set as empty
				</button>
				<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
					Clear
				</button>
			</div>
		);
	}

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	onAgentChange = evt => {
		if (evt.value) {
			this.setData('agentContent', evt.value);
		}
	};

	getAgentOptions = () => {
		let agents = [];
		_.forEach(this.data.agents, ag => {
			agents.push({
				label: ag.name,
				value: ag.name
			});
		});
		return agents;
	};

	render() {
		let {
			testing,
			actionType,
			headersOpen,
			bodyOpen,
			sslOpen,
			name,
			url,
			timeout,
			agentsOpen,
			agentContent,
			username,
			password,
			serverType,
			bodyContent,
			smtpAddress,
			impersonationMethod,
			additionalHeadersContent,
			securityMethodId,
			primarySmtpAddress,
			principalName,
			runningTest,
			async
		} = this.data;

		return (
			<div className="exchange-connector-cmp">
				<div className="step-card shadow animated fadeIn">
					<div className="hbox">
						<InputField
							label="Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="name"
							value={name}
							handleChange={this.onValueChange}
							disabled={this.props.connection ? true : false}
							required
							autoFocus
						/>
					</div>
					<div className="hbox">
						<InputField
							className="m-r-10"
							label="URL"
							subText="Base URL of the REST service."
							type="text"
							name="url"
							value={url}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('url')}
						/>

						<InputField
							label="Timeout"
							subText="Optional time to wait for the response headers in miliseconds. This must be lower than the global Platform timeout (10s)"
							type="number"
							name="timeout"
							value={timeout}
							handleChange={this.onValueChange}
						/>
					</div>
					<div className="vbox">
						<div className="toggle-sub-title">Authentication</div>
						<div className="sub-text">Credentials to authenticate to the Exchange service.</div>
					</div>
					<div className="hbox">
						<InputField
							className="m-r-10"
							label="Username"
							type="text"
							name="username"
							value={username}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('username')}
						/>

						<InputField
							label="Password"
							type="password"
							name="password"
							value={password}
							handleChange={this.onValueChange}
							disabled={this.getIsDisabled('password')}
						/>
					</div>

					<ToggleRow
						name="Request Headers"
						details="Note that if you define headers at connection-level you won't be able to define any header at endpoint-level"
						toggleOn={headersOpen}
						keyName={'headersOpen'}
						onToggle={this.onChecked}
						content={
							<div>
								<div className="server-content hbox vcenter">
									<Dropdown
										className="server-version-dd"
										label="Server version"
										value={serverType}
										handleChange={this.onServerChange}
										name="serverType"
										disabled={this.getIsDisabled('serverType')}
										options={[
											{
												label: 'Not specified',
												value: 'Not specified'
											},
											{
												label: 'Exchange 2007 (initial release)',
												value: 'Exchange2007'
											},
											{
												label: 'Exchange 2007 Service Pack 1, 2 and 3',
												value: 'Exchange2007_SP1'
											},
											{
												label: 'Exchange 2010 (initial release)',
												value: 'Exchange2010'
											},
											{
												label: 'Exchange 2010 Service Pack 1',
												value: 'Exchange2010_SP1'
											},
											{
												label: 'Exchange 2010 Service Pack 2 and 3',
												value: 'Exchange2010_SP2'
											}
										]}
									/>
								</div>
								<div className="vbox ignore-namespace-content">
									<div className="toggle-sub-title">Impersonation</div>
									<div className="sub-text">
										If an element in a "schema" definition depends on an Element which is present in the same namespace, normally the "tns:" namespace
										prefix is used to identify this Element. This is not much of a problem as long as you have just one "schema" defined (inline or in
										a separate file). If there are more "schema" files, the "tns:" in the generated "soap" file resolved mostly to the parent "wsdl"
										file, which was obviously wrong.
									</div>
									<div className="sub-text">
										The connector handles namespace prefixes which shouldn't be resolved (because it's not necessary) as so called ignored namespaces
										which default to this three 'tns', 'targetNamespace' and 'typedNamespace'. If this is not sufficient for your purpose you can
										easily add more namespace prefixes.
									</div>
								</div>
								<div className="hbox impersonate-ctn">
									<Dropdown
										className="impersonation-method-dd"
										label="Impersonation Method"
										value={impersonationMethod}
										handleChange={this.onImpersonationMethodChange}
										name="impersonationMethod"
										disabled={this.getIsDisabled('impersonationMethod')}
										options={[
											{
												label: 'Not specified',
												value: 'Not specified'
											},
											{
												label: 'User principal name (UPN)',
												value: 'PrincipalName'
											},
											{
												label: 'Security identifier (SID)',
												value: 'SID'
											},
											{
												label: 'Primary SMTP address',
												value: 'PrimarySmtpAddress'
											},
											{
												label: 'SMTP address',
												value: 'SmtpAddress'
											}
										]}
									/>
									{impersonationMethod === 'PrincipalName' && (
										<InputField
											label="User Principal Name"
											type="text"
											name="principalName"
											subText="The UPN method must define the fully qualified domain name (FQDN) for the location of the user account."
											value={principalName}
											handleChange={this.onValueChange}
											placeholder={'JohnDoe@corp.example.com'}
											disabled={this.getIsDisabled('principalName')}
										/>
									)}
									{impersonationMethod === 'SID' && (
										<InputField
											label="Security Identifier"
											type="text"
											name="securityMethodId"
											subText="The 'SID method' must define the security identifier of the account to be impersonated. This is the security descriptor definition language (SDDL) form of the SID."
											value={securityMethodId}
											handleChange={this.onValueChange}
											placeholder={'S-1-5-21-1493619105-1843311271-3936346804-1118'}
											disabled={this.getIsDisabled('securityMethodId')}
										/>
									)}
									{impersonationMethod === 'PrimarySmtpAddress' && (
										<InputField
											label="Primary SMTP address"
											type="text"
											name="primarySmtpAddress"
											subText="The Primary SMTP method must define the primary SMTP address that is used to create the connecting SID."
											value={primarySmtpAddress}
											handleChange={this.onValueChange}
											placeholder={'User2@example.com'}
											disabled={this.getIsDisabled('primarySmtpAddress')}
										/>
									)}
									{impersonationMethod === 'SmtpAddress' && (
										<InputField
											label="SMTP address"
											type="text"
											name="smtpAddress"
											subText="The SMTP address method must define the SMTP address of an account to be used for impersonation."
											value={smtpAddress}
											handleChange={this.onValueChange}
											placeholder={'User2@example.com'}
											disabled={this.getIsDisabled('smtpAddress')}
										/>
									)}
								</div>
								<div className="header-content vbox vcenter">
									<div className="toggle-sub-title">Additional Headers</div>
									<SmallJSONEditor
										name="additionalHeaders"
										value={additionalHeadersContent}
										onChange={this.handleAdditionalHeadersChange}
										readOnly={this.getIsDisabled('additionalHeadersContent')}
									/>
									<div className="json-message">
										Here you can add additional headers for the request. They will be merged with the ones defined above.
									</div>
								</div>
							</div>
						}
					/>
					<ToggleRow
						name="Request Body"
						details={
							this.props.endpoint
								? 'Exchange Web Services contains many XML elements that are used to define the requests and responses that are sent between the client and the server. Add elements for your endpoint operation body in this field.'
								: "Note that if you define a body at connection-level you won't be able to define it at endpoint-level."
						}
						toggleOn={bodyOpen}
						keyName={'bodyOpen'}
						onToggle={this.onChecked}
						icon={this.props.endpoint ? '' : <i className="mdi mdi-alert" />}
						content={
							<div className="header-content vbox vcenter">
								<SmallJSONEditor name="headers" value={bodyContent} onChange={this.handleBodyChange} readOnly={this.getIsDisabled('bodyContent')} />
								<div className="json-message">The request body must be defined as a valid JSON object</div>
							</div>
						}
					/>
					<ToggleRow
						name="SSL Certificate Validation"
						details="The SSL validation can be disabled altogether in order to request servers using a certificate signed by an unknown Certificate Authority or a self-signed certificate. This is insecure and is recommended for testing purposes only."
						toggleOn={sslOpen}
						keyName={'sslOpen'}
						onToggle={this.onChecked}
						disabled={this.props.endpoint ? true : false}
						offContent={
							<div className="json-message">
								<i className="mdi mdi-alert" /> Insecure
							</div>
						}
					/>
					{!this.props.endpoint && (
						<ToggleRow
							name="Use an On-premise agent"
							details={
								'An agent is a process that runs in a virtual machine installed in a secure network. Once configured, it establishes a Web Socket connection with the Core Services platform, enabling the use of connectors that would otherwise be unreachable from the cloud.'
							}
							toggleOn={agentsOpen}
							keyName={'agentsOpen'}
							onToggle={this.onChecked}
							disabled={this.getIsDisabled('agent')}
							content={
								<div className="body-content vbox vcenter">
									<Dropdown
										className="w-100"
										label="Agent"
										value={agentContent}
										handleChange={this.onAgentChange}
										name="agentContent"
										disabled={this.getIsDisabled('agent')}
										options={this.getAgentOptions()}
									/>
								</div>
							}
						/>
					)}
					{testing &&
						!this.props.endpoint && (
							<div className="test-ctn vbox">
								<SampleRequestCard
									requestParams={this.data.requestParams}
									buildRequestFields={this.buildTypeDefault}
									validTest={true}
									onTest={this.runTest}
									async={async}
									toggleAsync={this.toggleAsync}
									content={
										<div className="hbox hright">
											<InputField
												label="Operation"
												subText="Operations enable you to access information from the Exchange store."
												type="text"
												name="testOperation"
												value={actionType}
												handleChange={this.onActionChange}
												required
												autoFocus
											/>
										</div>
									}
								/>
								<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestConnection} async={async} />
							</div>
						)}
					<div className={`btn-ctn ${this.props.endpoint ? 'hidden' : ''}`}>
						<button className="btn m-r-20" onClick={this.onClearConnection}>
							{this.props.connection ? 'Undo Changes' : 'Clear'}
						</button>
						<button className="btn primary" onClick={this.onCreateConnection} disabled={this.isValidConnection()}>
							{this.props.connection ? 'Save Connection' : 'Create Connection'}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default ExchangeWebServiceConnector;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-creator/exchangewebservice-connector/ExchangeWebServiceConnector.js